import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { BackendApiService } from 'src/app/service/backend-api.service';

@Component({
  selector: 'app-candidature-hors-parcours',
  templateUrl: './candidature-hors-parcours.component.html',
  styleUrls: ['./candidature-hors-parcours.component.css'],
})
export class CandidatureHorsParcoursComponent implements OnInit {
  form!: FormGroup;

  certificatDynamicOption: any[] = [];
  selectedCertificates: number[] = [];
  selectedCohorte: string = '';
  // cohorteOption = [
  //   { name: '', label: '' },
  //   { name: 'HSIG2502_FODE', label: 'HSIG2502-FODE' },
  // ];
  cohorteOption: string[] = [];
  showConfirmModal = false;
  isEditMode = false;
  applicationId: number | null = null;
  isLoadingApplication = false;
  successMessage: string | null = null;
  isClosing = false;
  errorMessage: string | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private backendService: BackendApiService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.form = this.formBuilder.group({
      applicationName: ['', Validators.required],
      param: ['', Validators.required],
      applicationType: ['', Validators.required],
      applicationInformations: [''],
      openDate: [null, Validators.required],
      closeDate: [null, Validators.required],
      cohorte: [null, Validators.required],
      certificatChoiceList: this.formBuilder.array([]),
    });
  }

  get certificatsList() {
    return this.form.get('certificatsList') as FormArray;
  }

  get certificatChoiceList() {
    return this.form.get('certificatChoiceList') as FormArray;
  }

  ngOnInit(): void {
    this.getlistOffTrackCohorte();
    const idParam = this.route.snapshot.paramMap.get('id');
    console.log('idParam reçu :', idParam);
    if (idParam) {
      this.isEditMode = true;
      this.applicationId = +idParam;
      this.loadApplicationForEdit(this.applicationId);
    }
  }

  getlistOffTrackCohorte() {
    this.backendService.getListeOffTrackCohorte().subscribe({
      next: (response) => {
        this.cohorteOption = response;
        //console.log('liste des cohortessss : ', this.cohorteOption);
      },
    });
  }

  loadApplicationForEdit(id: number) {
    this.isLoadingApplication = true;
    this.backendService.getApplicationOffTrackById(id).subscribe({
      next: (response: any) => {
        const app = response?.object ?? response;


        const formatDate = (d: any): string | null => {
          if (!d) return null;

          const str = typeof d === 'string' ? d : new Date(d).toISOString();
          return str.substring(0, 10);
        };


        if (app.cohorte && !this.cohorteOption.includes(app.cohorte)) {
          this.cohorteOption = [app.cohorte, ...this.cohorteOption];
        }

        this.selectedCohorte = app.cohorte;


        this.form.patchValue({
          applicationName: app.applicationName,
          param: app.param,
          applicationType: app.applicationType,
          applicationInformations: app.applicationInformations,
          openDate: formatDate(app.openDate),
          closeDate: formatDate(app.closeDate),
          cohorte: app.cohorte,
        });
        this.form.get('openDate')?.disable();


        this.backendService.getCertificateByCohorte(app.cohorte).subscribe({
          next: (certResponse) => {
            this.certificatDynamicOption = certResponse?.object ?? [];

            // Les externalId des certificats déjà liés à cet appel
            const linkedExternalIds = (app.independentCertificateList || [])
              .map((c: any) => String(c.externalId ?? c.ExternalId ?? ''))
              .filter((v: string) => v !== '');

            // On ne garde que les certificats disponibles dans la cohorte
            // ET qui sont liés à cet appel — on prend la valeur ExternalId
            // telle qu'elle vient de getCertificateByCohorte pour garantir
            // la cohérence avec le [checked] du HTML
            this.selectedCertificates = this.certificatDynamicOption
              .filter((cert: any) =>
                linkedExternalIds.includes(String(cert.ExternalId ?? ''))
              )
              .map((cert: any) => cert.ExternalId);

            this.updateSelectedCertificatesInForm();
            this.isLoadingApplication = false;
          },
          error: (error) => {
            console.error('Erreur chargement certificats:', error);
            this.isLoadingApplication = false;
          },
        });
      },
      error: (error) => {
        console.error("Erreur chargement de l'appel à modifier:", error);
        this.isLoadingApplication = false;
      },
    });
  }

  isFieldInvalid(controlName: string): boolean | null {
    const controle = this.form.get(controlName);
    return controle && controle.invalid && controle.touched;
  }

  onCohorteChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.selectedCohorte = target.value;



    this.backendService
      .getCertificateByCohorte(this.selectedCohorte)
      .subscribe({
        next: (response) => {
          this.certificatDynamicOption = response?.object ?? [];

        },
        error: (error) => {
          console.error(
            'Erreur lors de la récupération des certificats:',
            error,
          );
          this.certificatDynamicOption = [];
        },
      });
  }


  onCheckboxChange(event: Event, certificatId: number) {
    const target = event.target as HTMLInputElement;
    if (target.checked) {

      if (!this.selectedCertificates.includes(certificatId)) {
        this.selectedCertificates = [
          ...this.selectedCertificates,
          certificatId,
        ];
      }
    } else {

      this.selectedCertificates = this.selectedCertificates.filter(
        (id) => id !== certificatId,
      );
    }


    this.updateSelectedCertificatesInForm();
  }


  updateSelectedCertificatesInForm() {
    const certificatChoiceList = this.certificatChoiceList;
    certificatChoiceList.clear();

    this.selectedCertificates.forEach((certificatId) => {
      certificatChoiceList.push(this.formBuilder.control(certificatId));
    });
  }

  openConfirmModal() {
    if (this.form.valid) {
      this.showConfirmModal = true;
    } else {
      this.form.markAllAsTouched();
    }
  }

  cancelSubmit() {
    this.showConfirmModal = false;
  }

  confirmSubmit() {
    this.showConfirmModal = false;
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    const formValue = this.form.getRawValue();
    const requestBody = {
      applicationName: formValue.applicationName,
      param: formValue.param?.trim(),
      applicationType: formValue.applicationType,
      applicationInformations: formValue.applicationInformations,
      openDate: formValue.openDate,
      closeDate: formValue.closeDate,
      cohorte: this.selectedCohorte,
      independentCertificateList: formValue.certificatChoiceList,
    };
    //console.log('isEditMode:', this.isEditMode, 'applicationId:', this.applicationId);
    if (this.isEditMode && this.applicationId) {
      this.backendService
        .updateApplicationOffTrack(this.applicationId, requestBody)
        .subscribe({
          next: () => {
            this.successMessage = "L'appel a été modifié avec succès.";
            setTimeout(() => {
              this.isClosing = true;
            }, 2300);
            setTimeout(() => {
              this.router.navigate(['dashboard', 'appels', 'listAppels'], {
                queryParams: { type: 'horsParcours' },
              });
            }, 2800);
          },
          error: (error: any) => {
            console.error("Erreur lors de la modification de l'appel :", error);
            this.errorMessage = "Une erreur est survenue lors de la modification de l'appel. Veuillez réessayer.";
            setTimeout(() => {
              this.errorMessage = null;
            }, 3000);
          },
        });
    } else {
      this.backendService.createApplicationOffTrack(requestBody).subscribe({
        next: () => {
          this.successMessage = "L'appel a été créé avec succès.";
          setTimeout(() => {
            this.isClosing = true;
          }, 2300);
          setTimeout(() => {
            this.router.navigate(['dashboard', 'appels', 'listAppels'], {
              queryParams: { type: 'horsParcours' },
            });
          }, 2800);
        },
        error: (error: any) => {
          console.error("Erreur lors de l'ajout des données :", error);
          this.errorMessage = "Une erreur est survenue lors de la création de l'appel. Veuillez réessayer.";
          setTimeout(() => {
            this.errorMessage = null;
          }, 3000);
        },
      });
    }
  }
  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'SIGUI' },
    { label: 'GESTION DES APPELS', url: '/dashboard/appels/listAppels' },
    {
      label: 'APPEL À CANDIDATURES HORS PARCOURS',
      url: '/dashboard/appels/candidatureHorsParcours',
    },
  ];
}
